import { createFileRoute } from "@tanstack/react-router";
import { EditarInsumoPage } from "@/paginas/editar-insumo";

export const Route = createFileRoute("/_authenticated/editar-insumo")({
  validateSearch: (
    s: Record<string, unknown>,
  ): { id?: string | undefined; voltar?: string | undefined } => ({
    id: typeof s["id"] === "string" ? (s["id"] as string) : undefined,
    voltar: typeof s["voltar"] === "string" ? (s["voltar"] as string) : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Insumo — Milky Moo Palmares" },
      {
        name: "description",
        content: "Altere dados, embalagem, custos e mínimos de um insumo do estoque.",
      },
      { property: "og:title", content: "Insumo — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Altere dados, embalagem, custos e mínimos de um insumo do estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: EditarInsumoPage,
});
